export const HAS_PUBLIC_TRANSPORT = ['PUBLIC', 'PARK_AND_RIDE', 'BIKE_AND_RIDE'];
export const VEHICLE_PUBLIC_COMBINED = ['PARK_AND_RIDE', 'BIKE_AND_RIDE'];

export const POI_TRANSPORT_MODES = [
    'CAR',
    'MOTORCYCLE',
    'TRAILER',
    'CAMPER',
];

export const TRAFFIC_TRANSPORT_MODES = [
    'CAR',
    'MOTORCYCLE',
    'TRAILER',
    'CAMPER',
    'PARK_AND_RIDE'
];

export const TRAFFIC_ALERT_TRANSPORT_MODES = [
    'CAR',
    // 'MOTORCYCLE',
    'TRAILER',
    'CAMPER',
]

export const NO_INTERMEDIATE_STOP_TRANSPORT_MODES = [
    ...HAS_PUBLIC_TRANSPORT,
    'SHARING'
]